import "./../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LinkCard from "../components/LinkCard";
import TextCard from "../components/TextCard";
import { EducationEntries } from "../data/LinkCardEntries";

export default function EducationLife() {
  const NACSText =
    '"I graduated from North Alabama Christian School, a private Christian umbrella school for homeschooling families. I graduated with a high school diploma and dual enrollment college credits. I love learning and am always looking to further my education and understand the world better."';

  return (
    <div className="App min-w-screen min-h-screen bg-home-page ">
      <Navbar />
      <h1 className="text-5xl text-center my-8">My Education</h1>
      <div className="px-80 mdw:px-40 smw:px-20 xsw:px-4 gap-10 flex flex-col place-content-evenly mb-8">
        <TextCard message={NACSText} />
        {EducationEntries.map((e) => (
          <LinkCard entry={e} />
        ))}
      </div>
      <Footer />
    </div>
  );
}
